import { formatToLongDate } from '@luminovo/frontend-utils';

/** The local calendar day as `yyyy-mm-dd`, the value shape of `FieldDate` and `FieldDatePicker`. */
export function toIsoDay(d: Date): string {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/** Local midnight of a `yyyy-mm-dd` day. */
export function fromIsoDay(s: string): Date {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, (m ?? 1) - 1, d ?? 1);
}

/** `''` for null or an invalid date. */
export function formatTriggerDate(value: string | Date | null | undefined): string {
    if (!value) return '';
    return formatToLongDate(value, { ifAbsent: '' });
}
